import {useCallback, useEffect, useState} from "react";
import {apiGet} from "../utils";
import {buildLegacyApiContext, hasDateFilters} from "../utils/filters";
import {WaterfallBarChart} from "../components/plotly/WaterfallBarChart";
import {WaterfallTablePanel} from "./WaterfallTablePanel";

export const MarginWaterfall = ({filters}) => {
    const [chartData, setChartData] = useState({});

    const fetchChartData = useCallback(() => {
        if (!hasDateFilters(filters)) {
            return;
        }
        const {period, granularity, queryParams} = buildLegacyApiContext(filters);
        apiGet(`calc/summary/waterfall/period/${period}/granularity/${granularity}${queryParams}`, (resp) => {
            setChartData(resp.data);
        });
    }, [filters]);

    useEffect(() => {
        fetchChartData();
    }, [fetchChartData]);

    return (
        <div style={{marginLeft: 30, marginRight: 30}}>
            <WaterfallBarChart title="Margin Waterfall" data={chartData}/>
            <WaterfallTablePanel filters={filters}/>
        </div>
    )
};
